// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings Page Styles */
.settings-container {
  padding: 1.5rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  /* Remove max-width and margin to allow full width */
  /* Remove fixed height and overflow as we're now using dashboard-content */
}

.settings-header {
  margin-bottom: 2rem;
}

.settings-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-dark, #212529);
  margin-bottom: 0.5rem;
}

.settings-subtitle {
  font-size: 0.9rem;
  color: var(--text-muted, #6c757d);
}

.settings-layout {
  display: flex;
  gap: 2rem;
  width: 100%;
  min-width: 0;
}

.settings-sidebar {
  width: 250px;
  flex-shrink: 0;
}

.settings-content {
  flex: 1 1;
  min-width: 0; /* Allow flex child to shrink below content width */
  max-width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  overflow-x: hidden; /* Contain horizontal overflow within the content pane */
  box-sizing: border-box;
  /* align-content: center;  */
}

.settings-nav {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.settings-nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: var(--text-dark, #212529);
  text-decoration: none;
  border-left: 3px solid transparent;
  transition: all 0.2s ease;
  cursor: pointer;
}

.settings-nav-item:hover {
  background-color: var(--bg-light, #f8f9fa);
}

.settings-nav-item.active {
  background-color: var(--bg-light, #f8f9fa);
  border-left-color: var(--primary-color, #4a6cf7);
  color: var(--primary-color, #4a6cf7);
}

.settings-nav-icon {
  margin-right: 0.75rem;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-section {
  margin-bottom: 2rem;
  min-width: 0;
  max-width: 100%;
}

.settings-section:last-child {
  margin-bottom: 0;
}

.settings-section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-dark, #212529);
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color-light, #e9ecef);
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-dark, #212529);
}

.form-input {
  width: 100%;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--border-color, #ced4da);
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  border-color: var(--primary-color, #4a6cf7);
  outline: none;
}

.form-input.error {
  border-color: var(--danger-color, #dc3545);
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper .form-input {
  padding-right: 2.5rem;
}

.password-visibility-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #6c757d);
}

.password-visibility-toggle:hover {
  color: var(--text-color, #343a40);
}

.form-error {
  color: var(--danger-color, #dc3545);
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.form-hint {
  color: var(--text-muted, #6c757d);
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.form-col {
  flex: 1 1;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color-light, #e9ecef);
}

.btn {
  padding: 0.6rem 1.25rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-primary {
  background-color: var(--primary-color, #4a6cf7);
  color: white;
  border: 1px solid var(--primary-color, #4a6cf7);
}

.btn-primary:hover {
  background-color: #3a5bd9;
}

.btn-outline {
  background-color: white;
  color: var(--text-dark, #212529);
  border: 1px solid var(--border-color, #ced4da);
  display: flex;
  justify-content: flex-end;
}

.btn-outline:hover {
  background-color: var(--bg-light, #f8f9fa);
  color: var(--text-dark, #212529);
}

.btn-danger {
  background-color: var(--danger-color, #dc3545);
  color: white;
  border: 1px solid var(--danger-color, #dc3545);
}

.btn-danger:hover {
  background-color: #c82333;
}

.btn-outline-danger {
  background-color: white;
  color: var(--danger-color, #dc3545);
  border: 1px solid var(--danger-color, #dc3545);
}

.btn-outline-danger:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .1s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: var(--primary-color, #4a6cf7);
}

input:focus + .toggle-slider {
  box-shadow: 0 0 1px var(--primary-color, #4a6cf7);
}

input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

/* Settings Specific Styles */
.profile-avatar-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.profile-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: var(--bg-light, #f8f9fa);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: 500;
  color: var(--primary-color, #4a6cf7);
  overflow: hidden;
}

.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  color: var(--primary-color, #4a6cf7);
}

.avatar-placeholder-icon {
  width: 2.6rem;
  height: 2.6rem;
  opacity: 0.8;
}

.avatar-placeholder-initials {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.profile-avatar.dragging {
  border: 2px dashed var(--primary-color, #4a6cf7);
}

.drag-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(74, 108, 247, 0.12);
  color: var(--primary-color, #4a6cf7);
}

.drag-overlay p {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 500;
}

.profile-avatar-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.avatar-upload-btn {
  padding: 0.5rem 1rem;
  background-color: white;
  border: 1px solid var(--border-color, #ced4da);
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.avatar-upload-btn:hover {
  background-color: var(--bg-light, #f8f9fa);
}

.avatar-upload-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.avatar-upload-hint {
  margin: 0;
  font-size: 0.75rem;
  color: var(--text-muted, #6c757d);
}

.avatar-remove-btn {
  color: var(--danger-color, #dc3545);
  background: none;
  border: none;
  padding: 0;
  font-size: 0.85rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.avatar-remove-btn:hover {
  text-decoration: underline;
}

.settings-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #fff 0%, var(--bg-light, #f8fafc) 100%);
  border: 1px solid var(--border-color-light, #e2e8f0);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 1rem 1.1rem;
  margin-bottom: 1rem;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.settings-card:hover {
  border-color: color-mix(in srgb, #2563eb 22%, var(--border-color-light, #e2e8f0));
  box-shadow: 0 10px 22px -16px rgba(15, 23, 42, 0.28);
}

.settings-card-title {
  font-weight: 700;
  letter-spacing: -0.01em;
  margin-bottom: 0.5rem;
  color: var(--text-dark, #0f172a);
}

.settings-card-description {
  font-size: 0.85rem;
  color: var(--text-muted, #6c757d);
  margin-bottom: 1rem;
}

.settings-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border-color-light, #e9ecef);
}

.settings-option:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.settings-option-label {
  font-weight: 500;
  color: var(--text-dark, #212529);
}

.settings-option-description {
  font-size: 0.85rem;
  color: var(--text-muted, #6c757d);
  margin-top: 0.25rem;
}

.settings-option-control {
  flex-shrink: 0;
}

.color-picker-container {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.color-option {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.color-option.active {
  border-color: var(--text-dark, #212529);
}

.settings-integrations-status-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
  padding-right: 5%;
}

.settings-integrations-status-row__label {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text-dark, #212529);
}

.integration-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--border-color-light, #e9ecef);
  border-radius: 6px;
  margin-bottom: 1rem;
}

.integration-logo {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-light, #f8f9fa);
  border-radius: 6px;
}

.integration-info {
  flex: 1 1;
}

.integration-name {
  font-weight: 600;
  color: var(--text-dark, #212529);
  margin-bottom: 0.25rem;
}

.integration-description {
  font-size: 0.85rem;
  color: var(--text-muted, #6c757d);
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.status-dot.connected {
  background-color: #28a745;
}

.integration-status .status-badge {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
  background-color: var(--bg-light, #f8f9fa);
}

.integration-status .status-badge.connected {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
}

.integration-status .status-badge.disconnected {
  color: var(--text-muted, #6c757d);
}

.integration-actions {
  margin-left: 1rem;
}

.danger-zone {
  background-color: rgba(220, 53, 69, 0.05);
  border: 1px solid rgba(220, 53, 69, 0.2);
  border-radius: 6px;
  padding: 1rem;
}

.danger-zone-title {
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.danger-zone-description {
  font-size: 0.85rem;
  color: var(--text-dark, #212529);
  margin-bottom: 1rem;
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e2e8f0;
  transition: all 0.2s ease;
  border-radius: 20px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: all 0.2s ease;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

input:checked + .toggle-slider {
  background-color: #4361ee;
}

input:disabled + .toggle-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

input:checked + .toggle-slider:before {
  transform: translateX(22px);
}

/* ─── Agents settings revamp ─── */
.agents-settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.agents-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--border-color-light, #e9ecef);
  background: var(--bg-light, #f8f9fa);
}

.agents-status--ok {
  border-color: rgba(40, 167, 69, 0.35);
  background: rgba(40, 167, 69, 0.08);
}

.agents-status--pending {
  border-color: rgba(67, 97, 238, 0.2);
}

.agents-status__main {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  min-width: 0;
}

.agents-status__icon {
  color: var(--text-muted, #6c757d);
  flex-shrink: 0;
  margin-top: 2px;
}

.agents-status__icon--ok {
  color: #28a745;
}

.agents-status__title {
  font-weight: 650;
  font-size: 0.95rem;
  color: var(--text-dark, #212529);
}

.agents-status__subtitle {
  font-size: 0.8125rem;
  color: var(--text-muted, #6c757d);
  margin-top: 0.15rem;
}

.agents-status__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.agents-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 550;
  color: var(--text-muted, #6c757d);
  background: white;
  border: 1px solid var(--border-color-light, #e9ecef);
}

.agents-pill--ok {
  color: #1e7e34;
  border-color: rgba(40, 167, 69, 0.35);
  background: rgba(40, 167, 69, 0.08);
}

.agents-pill__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.5;
}

.agents-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.agents-card {
  border: 1px solid var(--border-color-light, #e9ecef);
  border-radius: 10px;
  padding: 1rem 1.1rem;
  background: white;
  min-width: 0;
}

.agents-card--full {
  grid-column: 1 / -1;
}

.agents-card__header {
  margin-bottom: 0.9rem;
}

.agents-card__header--row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.agents-card__title {
  margin: 0 0 0.25rem;
  font-size: 0.95rem;
  font-weight: 650;
  color: var(--text-dark, #212529);
}

.agents-card__desc {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--text-muted, #6c757d);
  line-height: 1.45;
}

.agents-os-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.agents-os-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  padding: 0.85rem 0.5rem;
  border: 1px solid var(--border-color-light, #e9ecef);
  border-radius: 8px;
  background: var(--bg-light, #f8f9fa);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  color: var(--text-dark, #212529);
}

.agents-os-card:hover:not(:disabled) {
  border-color: var(--primary-color, #4a6cf7);
  background: white;
}

.agents-os-card--active {
  border-color: var(--primary-color, #4a6cf7);
  background: rgba(74, 108, 247, 0.06);
  box-shadow: inset 0 0 0 1px var(--primary-color, #4a6cf7);
}

.agents-os-card--disabled,
.agents-os-card:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.agents-os-card__label {
  font-size: 0.8125rem;
  font-weight: 600;
}

.agents-os-card__badge {
  font-size: 0.7rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: white;
  border: 1px solid var(--border-color-light, #e9ecef);
  color: var(--text-muted, #6c757d);
}

.agents-os-card__icon--linux {
  color: #e95420;
}

.agents-download-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 0.95rem;
  border-radius: 8px;
  border: 1px dashed rgba(74, 108, 247, 0.35);
  background: rgba(74, 108, 247, 0.04);
}

.agents-download-cta__label {
  font-size: 0.75rem;
  color: var(--text-muted, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 600;
}

.agents-download-cta__version {
  font-size: 0.95rem;
  font-weight: 650;
  color: var(--text-dark, #212529);
  margin-top: 0.15rem;
}

.agents-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.agents-steps__item {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.agents-steps__num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--primary-color, #4a6cf7);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}

.agents-steps__title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-dark, #212529);
}

.agents-steps__detail {
  font-size: 0.78rem;
  color: var(--text-muted, #6c757d);
  margin-top: 0.15rem;
  line-height: 1.45;
}

.agents-terminal {
  margin-top: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  background: #1e2430;
  color: #e8ecf4;
  font-size: 0.78rem;
  overflow-x: auto;
}

.agents-terminal code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: nowrap;
}

.agents-empty {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.75rem 1rem;
  text-align: center;
  color: var(--text-muted, #6c757d);
  font-size: 0.875rem;
  border: 1px dashed var(--border-color-light, #e9ecef);
  border-radius: 8px;
}

.agents-empty__title {
  font-weight: 650;
  color: var(--text-dark, #212529);
  margin-bottom: 0.15rem;
}

.agents-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border-color-light, #e9ecef);
  border-radius: 8px;
}

.agents-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.agents-table th,
.agents-table td {
  padding: 0.75rem 0.9rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light, #e9ecef);
  vertical-align: middle;
}

.agents-table th {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted, #6c757d);
  background: var(--bg-light, #f8f9fa);
  font-weight: 650;
}

.agents-table tr:last-child td {
  border-bottom: none;
}

.agents-table__row--latest {
  background: rgba(40, 167, 69, 0.06);
}

.agents-table__version {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-weight: 600;
}

.agents-badge-latest {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  background: #28a745;
  color: white;
}

.agents-table__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
}

@keyframes agents-spin {
  to {
    transform: rotate(360deg);
  }
}

.agents-spin {
  animation: agents-spin 0.8s linear infinite;
}

/* ─── Upload Agent modal ─── */
.agents-upload-overlay {
  z-index: 12000;
  backdrop-filter: blur(2px);
}

.agents-upload-dialog {
  width: min(460px, 100%);
  padding: 0;
  overflow: hidden;
}

.agents-upload-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--rt-border, var(--border-color-light, #e9ecef));
  background:
    linear-gradient(180deg, rgba(74, 108, 247, 0.06), transparent 70%),
    var(--rt-surface, #fff);
}

.agents-upload-dialog__brand {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.agents-upload-dialog__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(74, 108, 247, 0.1);
  color: var(--rt-primary, #4a6cf7);
  border: 1px solid rgba(74, 108, 247, 0.18);
}

.agents-upload-dialog__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--rt-text, var(--text-dark, #212529));
  line-height: 1.3;
}

.agents-upload-dialog__subtitle {
  margin: 4px 0 0;
  font-size: 0.8125rem;
  color: var(--rt-text-secondary, var(--text-muted, #6c757d));
  line-height: 1.4;
}

.agents-upload-dialog__subtitle strong {
  color: var(--rt-text, var(--text-dark, #212529));
  font-weight: 650;
}

.agents-upload-dialog__close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--rt-text-secondary, #6c757d);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.agents-upload-dialog__close:hover:not(:disabled) {
  background: var(--rt-bg, #f8f9fa);
  color: var(--rt-text, #212529);
}

.agents-upload-dialog__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agents-upload-dialog__form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 18px 18px;
}

.agents-upload-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agents-upload-field__label {
  font-size: 0.8125rem;
  font-weight: 650;
  color: var(--rt-text, var(--text-dark, #212529));
}

.agents-upload-field__hint {
  margin: 0;
  font-size: 0.75rem;
  color: var(--rt-text-secondary, var(--text-muted, #6c757d));
  line-height: 1.4;
}

.agents-upload-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.agents-upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 118px;
  padding: 18px 16px;
  text-align: center;
  border: 1.5px dashed var(--rt-border, #ced4da);
  border-radius: 12px;
  background: var(--rt-bg, #f8f9fa);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.agents-upload-dropzone:hover,
.agents-upload-dropzone--dragging {
  border-color: var(--rt-primary, #4a6cf7);
  background: rgba(74, 108, 247, 0.05);
  box-shadow: inset 0 0 0 1px rgba(74, 108, 247, 0.15);
}

.agents-upload-dropzone--filled {
  border-style: solid;
  border-color: rgba(74, 108, 247, 0.35);
  background: rgba(74, 108, 247, 0.04);
}

.agents-upload-dropzone--disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.agents-upload-dropzone__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid var(--rt-border, #e9ecef);
  color: var(--rt-primary, #4a6cf7);
  margin-bottom: 2px;
}

.agents-upload-dropzone__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--rt-text, #212529);
  word-break: break-word;
}

.agents-upload-dropzone__hint {
  font-size: 0.75rem;
  color: var(--rt-text-secondary, #6c757d);
  line-height: 1.4;
}

.agents-upload-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--rt-border, #ced4da);
  border-radius: 8px;
  background: var(--rt-surface, #fff);
  color: var(--rt-text, #212529);
  font: inherit;
  font-size: 0.875rem;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.agents-upload-input:focus {
  border-color: var(--rt-primary, #4a6cf7);
  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.15);
}

.agents-upload-input:disabled {
  background: var(--rt-bg, #f8f9fa);
  opacity: 0.75;
  cursor: not-allowed;
}

.agents-upload-error {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(220, 53, 69, 0.25);
  background: rgba(220, 53, 69, 0.08);
  color: #b02a37;
  font-size: 0.8125rem;
  line-height: 1.4;
}

.agents-upload-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}

/* Responsive Adjustments */
@media (max-width: 900px) {
  .agents-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .settings-layout {
    flex-direction: column;
  }
  
  .settings-sidebar {
    width: 100%;
  }
  
  .settings-nav {
    margin-bottom: 1.5rem;
  }
  
  .form-row {
    flex-direction: column;
    gap: 1.25rem;
  }

  .agents-os-grid {
    grid-template-columns: 1fr;
  }

  .agents-download-cta,
  .agents-card__header--row,
  .agents-status {
    flex-direction: column;
    align-items: stretch;
  }

  .agents-table__actions {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/settings.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,0EAA0E;AAC5E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,mDAAmD;EACjE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,kBAAkB,EAAE,wDAAwD;EAC5E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2EAA2E;EAC3E,oDAAoD;EACpD,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,iFAAiF;EACjF,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,0DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6EAA6E;EAC7E;;2BAEyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,iFAAiF;AACnF;;AAEA;;EAEE,wCAAwC;EACxC,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Settings Page Styles */\n.settings-container {\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  /* Remove max-width and margin to allow full width */\n  /* Remove fixed height and overflow as we're now using dashboard-content */\n}\n\n.settings-header {\n  margin-bottom: 2rem;\n}\n\n.settings-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-dark, #212529);\n  margin-bottom: 0.5rem;\n}\n\n.settings-subtitle {\n  font-size: 0.9rem;\n  color: var(--text-muted, #6c757d);\n}\n\n.settings-layout {\n  display: flex;\n  gap: 2rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.settings-sidebar {\n  width: 250px;\n  flex-shrink: 0;\n}\n\n.settings-content {\n  flex: 1;\n  min-width: 0; /* Allow flex child to shrink below content width */\n  max-width: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  overflow-x: hidden; /* Contain horizontal overflow within the content pane */\n  box-sizing: border-box;\n  /* align-content: center;  */\n}\n\n.settings-nav {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.settings-nav-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  color: var(--text-dark, #212529);\n  text-decoration: none;\n  border-left: 3px solid transparent;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.settings-nav-item:hover {\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.settings-nav-item.active {\n  background-color: var(--bg-light, #f8f9fa);\n  border-left-color: var(--primary-color, #4a6cf7);\n  color: var(--primary-color, #4a6cf7);\n}\n\n.settings-nav-icon {\n  margin-right: 0.75rem;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-section {\n  margin-bottom: 2rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.settings-section:last-child {\n  margin-bottom: 0;\n}\n\n.settings-section-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-dark, #212529);\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-color-light, #e9ecef);\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-dark, #212529);\n}\n\n.form-input {\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--border-color, #ced4da);\n  border-radius: 4px;\n  font-size: 0.9rem;\n  transition: border-color 0.2s ease;\n}\n\n.form-input:focus {\n  border-color: var(--primary-color, #4a6cf7);\n  outline: none;\n}\n\n.form-input.error {\n  border-color: var(--danger-color, #dc3545);\n}\n\n.password-input-wrapper {\n  position: relative;\n}\n\n.password-input-wrapper .form-input {\n  padding-right: 2.5rem;\n}\n\n.password-visibility-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #6c757d);\n}\n\n.password-visibility-toggle:hover {\n  color: var(--text-color, #343a40);\n}\n\n.form-error {\n  color: var(--danger-color, #dc3545);\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n.form-hint {\n  color: var(--text-muted, #6c757d);\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.form-col {\n  flex: 1;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-color-light, #e9ecef);\n}\n\n.btn {\n  padding: 0.6rem 1.25rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.btn-primary {\n  background-color: var(--primary-color, #4a6cf7);\n  color: white;\n  border: 1px solid var(--primary-color, #4a6cf7);\n}\n\n.btn-primary:hover {\n  background-color: #3a5bd9;\n}\n\n.btn-outline {\n  background-color: white;\n  color: var(--text-dark, #212529);\n  border: 1px solid var(--border-color, #ced4da);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-outline:hover {\n  background-color: var(--bg-light, #f8f9fa);\n  color: var(--text-dark, #212529);\n}\n\n.btn-danger {\n  background-color: var(--danger-color, #dc3545);\n  color: white;\n  border: 1px solid var(--danger-color, #dc3545);\n}\n\n.btn-danger:hover {\n  background-color: #c82333;\n}\n\n.btn-outline-danger {\n  background-color: white;\n  color: var(--danger-color, #dc3545);\n  border: 1px solid var(--danger-color, #dc3545);\n}\n\n.btn-outline-danger:hover {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .1s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: var(--primary-color, #4a6cf7);\n}\n\ninput:focus + .toggle-slider {\n  box-shadow: 0 0 1px var(--primary-color, #4a6cf7);\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n/* Settings Specific Styles */\n.profile-avatar-section {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.profile-avatar {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background-color: var(--bg-light, #f8f9fa);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  font-weight: 500;\n  color: var(--primary-color, #4a6cf7);\n  overflow: hidden;\n}\n\n.profile-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.15rem;\n  color: var(--primary-color, #4a6cf7);\n}\n\n.avatar-placeholder-icon {\n  width: 2.6rem;\n  height: 2.6rem;\n  opacity: 0.8;\n}\n\n.avatar-placeholder-initials {\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.profile-avatar.dragging {\n  border: 2px dashed var(--primary-color, #4a6cf7);\n}\n\n.drag-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: rgba(74, 108, 247, 0.12);\n  color: var(--primary-color, #4a6cf7);\n}\n\n.drag-overlay p {\n  margin: 0;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.profile-avatar-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.avatar-upload-btn {\n  padding: 0.5rem 1rem;\n  background-color: white;\n  border: 1px solid var(--border-color, #ced4da);\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.avatar-upload-btn:hover {\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.avatar-upload-btn.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.avatar-upload-hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--text-muted, #6c757d);\n}\n\n.avatar-remove-btn {\n  color: var(--danger-color, #dc3545);\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 0.85rem;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.avatar-remove-btn:hover {\n  text-decoration: underline;\n}\n\n.settings-card {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(180deg, #fff 0%, var(--bg-light, #f8fafc) 100%);\n  border: 1px solid var(--border-color-light, #e2e8f0);\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  padding: 1rem 1.1rem;\n  margin-bottom: 1rem;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.settings-card:hover {\n  border-color: color-mix(in srgb, #2563eb 22%, var(--border-color-light, #e2e8f0));\n  box-shadow: 0 10px 22px -16px rgba(15, 23, 42, 0.28);\n}\n\n.settings-card-title {\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  margin-bottom: 0.5rem;\n  color: var(--text-dark, #0f172a);\n}\n\n.settings-card-description {\n  font-size: 0.85rem;\n  color: var(--text-muted, #6c757d);\n  margin-bottom: 1rem;\n}\n\n.settings-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border-color-light, #e9ecef);\n}\n\n.settings-option:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.settings-option-label {\n  font-weight: 500;\n  color: var(--text-dark, #212529);\n}\n\n.settings-option-description {\n  font-size: 0.85rem;\n  color: var(--text-muted, #6c757d);\n  margin-top: 0.25rem;\n}\n\n.settings-option-control {\n  flex-shrink: 0;\n}\n\n.color-picker-container {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.color-option {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.color-option.active {\n  border-color: var(--text-dark, #212529);\n}\n\n.settings-integrations-status-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 0.5rem;\n  padding-right: 5%;\n}\n\n.settings-integrations-status-row__label {\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: var(--text-dark, #212529);\n}\n\n.integration-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  border: 1px solid var(--border-color-light, #e9ecef);\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.integration-logo {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-light, #f8f9fa);\n  border-radius: 6px;\n}\n\n.integration-info {\n  flex: 1;\n}\n\n.integration-name {\n  font-weight: 600;\n  color: var(--text-dark, #212529);\n  margin-bottom: 0.25rem;\n}\n\n.integration-description {\n  font-size: 0.85rem;\n  color: var(--text-muted, #6c757d);\n}\n\n.status-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n}\n\n.status-dot.connected {\n  background-color: #28a745;\n}\n\n.integration-status .status-badge {\n  display: flex;\n  align-items: center;\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 20px;\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.integration-status .status-badge.connected {\n  color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n}\n\n.integration-status .status-badge.disconnected {\n  color: var(--text-muted, #6c757d);\n}\n\n.integration-actions {\n  margin-left: 1rem;\n}\n\n.danger-zone {\n  background-color: rgba(220, 53, 69, 0.05);\n  border: 1px solid rgba(220, 53, 69, 0.2);\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.danger-zone-title {\n  color: #dc3545;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.danger-zone-description {\n  font-size: 0.85rem;\n  color: var(--text-dark, #212529);\n  margin-bottom: 1rem;\n}\n\n/* Toggle Switch Styles */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 22px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #e2e8f0;\n  transition: all 0.2s ease;\n  border-radius: 20px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: all 0.2s ease;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\ninput:checked + .toggle-slider {\n  background-color: #4361ee;\n}\n\ninput:disabled + .toggle-slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(22px);\n}\n\n/* ─── Agents settings revamp ─── */\n.agents-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.agents-status {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.9rem 1rem;\n  border-radius: 10px;\n  border: 1px solid var(--border-color-light, #e9ecef);\n  background: var(--bg-light, #f8f9fa);\n}\n\n.agents-status--ok {\n  border-color: rgba(40, 167, 69, 0.35);\n  background: rgba(40, 167, 69, 0.08);\n}\n\n.agents-status--pending {\n  border-color: rgba(67, 97, 238, 0.2);\n}\n\n.agents-status__main {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.agents-status__icon {\n  color: var(--text-muted, #6c757d);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.agents-status__icon--ok {\n  color: #28a745;\n}\n\n.agents-status__title {\n  font-weight: 650;\n  font-size: 0.95rem;\n  color: var(--text-dark, #212529);\n}\n\n.agents-status__subtitle {\n  font-size: 0.8125rem;\n  color: var(--text-muted, #6c757d);\n  margin-top: 0.15rem;\n}\n\n.agents-status__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.agents-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 550;\n  color: var(--text-muted, #6c757d);\n  background: white;\n  border: 1px solid var(--border-color-light, #e9ecef);\n}\n\n.agents-pill--ok {\n  color: #1e7e34;\n  border-color: rgba(40, 167, 69, 0.35);\n  background: rgba(40, 167, 69, 0.08);\n}\n\n.agents-pill__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.5;\n}\n\n.agents-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.agents-card {\n  border: 1px solid var(--border-color-light, #e9ecef);\n  border-radius: 10px;\n  padding: 1rem 1.1rem;\n  background: white;\n  min-width: 0;\n}\n\n.agents-card--full {\n  grid-column: 1 / -1;\n}\n\n.agents-card__header {\n  margin-bottom: 0.9rem;\n}\n\n.agents-card__header--row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.agents-card__title {\n  margin: 0 0 0.25rem;\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: var(--text-dark, #212529);\n}\n\n.agents-card__desc {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--text-muted, #6c757d);\n  line-height: 1.45;\n}\n\n.agents-os-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.6rem;\n  margin-bottom: 1rem;\n}\n\n.agents-os-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.85rem 0.5rem;\n  border: 1px solid var(--border-color-light, #e9ecef);\n  border-radius: 8px;\n  background: var(--bg-light, #f8f9fa);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n  color: var(--text-dark, #212529);\n}\n\n.agents-os-card:hover:not(:disabled) {\n  border-color: var(--primary-color, #4a6cf7);\n  background: white;\n}\n\n.agents-os-card--active {\n  border-color: var(--primary-color, #4a6cf7);\n  background: rgba(74, 108, 247, 0.06);\n  box-shadow: inset 0 0 0 1px var(--primary-color, #4a6cf7);\n}\n\n.agents-os-card--disabled,\n.agents-os-card:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.agents-os-card__label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.agents-os-card__badge {\n  font-size: 0.7rem;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  background: white;\n  border: 1px solid var(--border-color-light, #e9ecef);\n  color: var(--text-muted, #6c757d);\n}\n\n.agents-os-card__icon--linux {\n  color: #e95420;\n}\n\n.agents-download-cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: 8px;\n  border: 1px dashed rgba(74, 108, 247, 0.35);\n  background: rgba(74, 108, 247, 0.04);\n}\n\n.agents-download-cta__label {\n  font-size: 0.75rem;\n  color: var(--text-muted, #6c757d);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  font-weight: 600;\n}\n\n.agents-download-cta__version {\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: var(--text-dark, #212529);\n  margin-top: 0.15rem;\n}\n\n.agents-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.agents-steps__item {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n}\n\n.agents-steps__num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--primary-color, #4a6cf7);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.agents-steps__title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-dark, #212529);\n}\n\n.agents-steps__detail {\n  font-size: 0.78rem;\n  color: var(--text-muted, #6c757d);\n  margin-top: 0.15rem;\n  line-height: 1.45;\n}\n\n.agents-terminal {\n  margin-top: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  background: #1e2430;\n  color: #e8ecf4;\n  font-size: 0.78rem;\n  overflow-x: auto;\n}\n\n.agents-terminal code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  white-space: nowrap;\n}\n\n.agents-empty {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1.75rem 1rem;\n  text-align: center;\n  color: var(--text-muted, #6c757d);\n  font-size: 0.875rem;\n  border: 1px dashed var(--border-color-light, #e9ecef);\n  border-radius: 8px;\n}\n\n.agents-empty__title {\n  font-weight: 650;\n  color: var(--text-dark, #212529);\n  margin-bottom: 0.15rem;\n}\n\n.agents-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border-color-light, #e9ecef);\n  border-radius: 8px;\n}\n\n.agents-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.agents-table th,\n.agents-table td {\n  padding: 0.75rem 0.9rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light, #e9ecef);\n  vertical-align: middle;\n}\n\n.agents-table th {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--text-muted, #6c757d);\n  background: var(--bg-light, #f8f9fa);\n  font-weight: 650;\n}\n\n.agents-table tr:last-child td {\n  border-bottom: none;\n}\n\n.agents-table__row--latest {\n  background: rgba(40, 167, 69, 0.06);\n}\n\n.agents-table__version {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-weight: 600;\n}\n\n.agents-badge-latest {\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 0.12rem 0.45rem;\n  border-radius: 999px;\n  background: #28a745;\n  color: white;\n}\n\n.agents-table__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.4rem;\n}\n\n@keyframes agents-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.agents-spin {\n  animation: agents-spin 0.8s linear infinite;\n}\n\n/* ─── Upload Agent modal ─── */\n.agents-upload-overlay {\n  z-index: 12000;\n  backdrop-filter: blur(2px);\n}\n\n.agents-upload-dialog {\n  width: min(460px, 100%);\n  padding: 0;\n  overflow: hidden;\n}\n\n.agents-upload-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--rt-border, var(--border-color-light, #e9ecef));\n  background:\n    linear-gradient(180deg, rgba(74, 108, 247, 0.06), transparent 70%),\n    var(--rt-surface, #fff);\n}\n\n.agents-upload-dialog__brand {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.agents-upload-dialog__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: rgba(74, 108, 247, 0.1);\n  color: var(--rt-primary, #4a6cf7);\n  border: 1px solid rgba(74, 108, 247, 0.18);\n}\n\n.agents-upload-dialog__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--rt-text, var(--text-dark, #212529));\n  line-height: 1.3;\n}\n\n.agents-upload-dialog__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.8125rem;\n  color: var(--rt-text-secondary, var(--text-muted, #6c757d));\n  line-height: 1.4;\n}\n\n.agents-upload-dialog__subtitle strong {\n  color: var(--rt-text, var(--text-dark, #212529));\n  font-weight: 650;\n}\n\n.agents-upload-dialog__close {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--rt-text-secondary, #6c757d);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.agents-upload-dialog__close:hover:not(:disabled) {\n  background: var(--rt-bg, #f8f9fa);\n  color: var(--rt-text, #212529);\n}\n\n.agents-upload-dialog__close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agents-upload-dialog__form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px 18px 18px;\n}\n\n.agents-upload-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.agents-upload-field__label {\n  font-size: 0.8125rem;\n  font-weight: 650;\n  color: var(--rt-text, var(--text-dark, #212529));\n}\n\n.agents-upload-field__hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--rt-text-secondary, var(--text-muted, #6c757d));\n  line-height: 1.4;\n}\n\n.agents-upload-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n}\n\n.agents-upload-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 118px;\n  padding: 18px 16px;\n  text-align: center;\n  border: 1.5px dashed var(--rt-border, #ced4da);\n  border-radius: 12px;\n  background: var(--rt-bg, #f8f9fa);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agents-upload-dropzone:hover,\n.agents-upload-dropzone--dragging {\n  border-color: var(--rt-primary, #4a6cf7);\n  background: rgba(74, 108, 247, 0.05);\n  box-shadow: inset 0 0 0 1px rgba(74, 108, 247, 0.15);\n}\n\n.agents-upload-dropzone--filled {\n  border-style: solid;\n  border-color: rgba(74, 108, 247, 0.35);\n  background: rgba(74, 108, 247, 0.04);\n}\n\n.agents-upload-dropzone--disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.agents-upload-dropzone__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border: 1px solid var(--rt-border, #e9ecef);\n  color: var(--rt-primary, #4a6cf7);\n  margin-bottom: 2px;\n}\n\n.agents-upload-dropzone__title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--rt-text, #212529);\n  word-break: break-word;\n}\n\n.agents-upload-dropzone__hint {\n  font-size: 0.75rem;\n  color: var(--rt-text-secondary, #6c757d);\n  line-height: 1.4;\n}\n\n.agents-upload-input {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--rt-border, #ced4da);\n  border-radius: 8px;\n  background: var(--rt-surface, #fff);\n  color: var(--rt-text, #212529);\n  font: inherit;\n  font-size: 0.875rem;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.agents-upload-input:focus {\n  border-color: var(--rt-primary, #4a6cf7);\n  box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.15);\n}\n\n.agents-upload-input:disabled {\n  background: var(--rt-bg, #f8f9fa);\n  opacity: 0.75;\n  cursor: not-allowed;\n}\n\n.agents-upload-error {\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(220, 53, 69, 0.25);\n  background: rgba(220, 53, 69, 0.08);\n  color: #b02a37;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n}\n\n.agents-upload-dialog__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-top: 4px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 900px) {\n  .agents-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .settings-layout {\n    flex-direction: column;\n  }\n  \n  .settings-sidebar {\n    width: 100%;\n  }\n  \n  .settings-nav {\n    margin-bottom: 1.5rem;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n\n  .agents-os-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .agents-download-cta,\n  .agents-card__header--row,\n  .agents-status {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .agents-table__actions {\n    justify-content: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
